// Project settings
export const GUID_FOR_INITIAL_TOPIC_NAME = 'c774da81-94d5-4652-85c7-6ed0e8dc67e6';

// Project configurations
export const INITIAL_MESSAGES_SIZE = 2000;
export const MAXIMUM_LENGTH_OF_NAME = 10;
export const MAXIMUM_LENGTH_OF_MESSAGE = 8000;
export const MAXIMUM_LENGTH_OF_TOPIC = 30;
export const MAXIMUM_LENGTH_OF_TYPING_USERS = 35;
export const MINIMUM_TYPING_INTERVAL_IN_MILLISECONDS = 8000;
export const MAXIMUM_INT64 = 9223372036854775807;
export const NUMBER_OF_MESSAGES_TO_LOAD = 10;
export const PAGE_SIZE = 200;
export const PARTICIPANTS_THRESHOLD = 20;

// Keyboard keys
export const ENTER_KEY = 13;
export const SPACE_KEY = 32;

// Http Status Code
export const OK = 200;

// Regex
export const URL_REGEX = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/;
export const EMPTY_MESSAGE_REGEX = /^\s*$/;

export const GLOBAL_URL = 'https://as-az-dev.azurewebsites.net/api/CS/';
export const DEV_GLOBAL_URL = `${window.location.origin}/`;
//console.log(DEV_GLOBAL_URL, 'DEV_GLOBAL_URL')
//export const DEV_GLOBAL_URL = 'https://localhost:7180/';
export const Default_URL = `${window.location.origin}/`;
